import React, { ReactNode } from 'react'
import { useDeviceType } from '../../hooks/useDeviceType'
import DesktopLayout from './DesktopLayout'
import MobileLayout from './MobileLayout'

interface ResponsiveLayoutProps {
  children: ReactNode
  onShowAuthModal: () => void
  onShowProfile: () => void
  onShowCreate: () => void
  onShowHistory: () => void
  onShowSavedFeet: () => void
  onShowDiscover: () => void
  onShowGift?: () => void
  onShowRedemption?: () => void
  onShowGlobalSearch?: () => void
  activeTab?: 'create' | 'history' | 'savedFeet' | 'discover' | null
  authMode: 'signin' | 'signup'
  setAuthMode: (mode: 'signin' | 'signup') => void
  // Desktop-specific props
  showFilters?: boolean
  onToggleFilters?: () => void
  prompt?: string
  onPromptChange?: (value: string) => void
  onGenerate?: () => void
  isGenerating?: boolean
  filterSection?: ReactNode
  discoverSection?: ReactNode
  // Generation limit props
  canGenerate?: boolean
  remainingGenerations?: number
  // Image upload props
  uploadedImages?: File[]
  onImagesChange?: (images: File[]) => void
}

const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = (props) => {
  const { isDesktop, isTablet } = useDeviceType()

  // Use desktop layout for desktop and tablet, mobile layout for mobile
  if (isDesktop || isTablet) {
    return <DesktopLayout {...props} />
  }

  // For mobile, only pass the props that MobileLayout expects
  const mobileProps = {
    children: props.children,
    onShowAuthModal: props.onShowAuthModal,
    onShowProfile: props.onShowProfile,
    onShowCreate: props.onShowCreate,
    onShowHistory: props.onShowHistory,
    onShowSavedFeet: props.onShowSavedFeet,
    onShowDiscover: props.onShowDiscover,
    onShowGift: props.onShowGift,
    onShowRedemption: props.onShowRedemption,
    onShowGlobalSearch: props.onShowGlobalSearch,
    activeTab: props.activeTab,
    setAuthMode: props.setAuthMode
  }

  return <MobileLayout {...mobileProps} />
}

export default ResponsiveLayout 